import React, { ReactElement, ReactNode, RefObject } from 'react';
import { createPortal } from 'react-dom';
import SvgIcon from './svg-icon';

type ModalProps = {
  id: string,
  title?: ReactNode,
  titleClass?: string,
  className?: string,
  body: ReactNode,
  footer?: ReactNode,
  withoutClose?: boolean,
  modalRef?: RefObject<HTMLDivElement>,
  small?: boolean,
  large?: boolean,
  show?: boolean,
  onClose?: () => void,
  closeButton?: ReactElement,
  ariaLabel?: string,
}

const Modal: React.FC<ModalProps> = ({
  title,
  id,
  className,
  titleClass,
  body,
  footer,
  withoutClose,
  modalRef,
  small,
  large,
  show,
  onClose,
  closeButton,
  ariaLabel
}) => {
  const titleId = `${id}-title`;

  if (!show) {
    return null;
  }

  const renderCloseButton = () => {
    if (withoutClose) { return null; }

    return closeButton ?? (
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        data-dismiss="modal"
        data-bs-dismiss="modal"
        onClick={() => {
          if (onClose) { onClose(); }
        }}
      />
    );
  };

  let sizeClass = '';
  if (small) { sizeClass = ' modal-sm'; } else if (large) { sizeClass = ' modal-lg'; }

  return createPortal((
    <div
      className={`modal fade in show${className ? ` ${className}` : ''}`}
      style={{
        display: 'block',
        paddingRight: '17px',
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
      role="dialog"
      aria-labelledby={title ? titleId : undefined}
      aria-label={!title ? (ariaLabel ?? 'Modal dialog') : undefined}
      aria-modal="true"
      tabIndex={-1}
      id={id}
      ref={modalRef}
    >
      <div className={`modal-dialog${sizeClass}`}>
        <div className="modal-content">
          {(title || !withoutClose) && (
            <div className="modal-header">
              {renderCloseButton()}
              {title && (
                <h4
                  className={`m-0 modal-title text-start${titleClass ? ` ${titleClass}` : ''}`}
                  id={titleId}
                >
                  {title}
                </h4>
              )}
            </div>
          )}
          <div className="modal-body bg-white">
            {body}
          </div>
          {footer && (
            <div className="modal-footer bg-white">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  ), document.body);
};

export default Modal;
